export default "__VITE_ASSET__DfkxeSYt__";